export enum RoutingPath {
    Home = '/',
    SignIn = '/signin',
    Register = '/register',
    Attendance = 'attendance',
    Kitchen = "kitchen",
    Candidates = "candidates",
    Settings = "settings",
};